export default __webpack_public_path__ + "hamburger-menu-normal.254ea3760e8a2a0d8aa1.svg";